import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { initAnalytics, trackPageView, trackWhatsAppClick } from "@/analytics";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import HomePage from "@/pages/HomePage";
import ToursPage from "@/pages/ToursPage";
import TourDetailPage from "@/pages/TourDetailPage";
import ExperiencesPage from "@/pages/ExperiencesPage";
import AboutPage from "@/pages/AboutPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import BookingPage from "@/pages/BookingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminCalendar from "@/pages/admin/AdminCalendar";
import AdminTours from "@/pages/admin/AdminTours";
import AdminClients from "@/pages/admin/AdminClients";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminSettings from "@/pages/admin/AdminSettings";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AnalyticsTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    initAnalytics();
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href*="wa.me"]');
      if (a) trackWhatsAppClick(window.location.pathname);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="App min-h-screen bg-[#050908]">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tours" element={<ToursPage />} />
          <Route path="/tours/:slug" element={<TourDetailPage />} />
          <Route path="/experiencias" element={<ExperiencesPage />} />
          <Route path="/nosotros" element={<AboutPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/reservar" element={<BookingPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="reservas" element={<AdminBookings />} />
            <Route path="calendario" element={<AdminCalendar />} />
            <Route path="tours" element={<AdminTours />} />
            <Route path="clientes" element={<AdminClients />} />
            <Route path="pagos" element={<AdminPayments />} />
            <Route path="equipo" element={<AdminTeam />} />
            <Route path="configuracion" element={<AdminSettings />} />
          </Route>
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
    </>
  );
}
